<template>
  <div class="fc-page">

    <!-- Hero -->
    <div class="fc-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-school-outline</v-icon>
        </v-avatar>
        <div>
          <div class="fc-hero__title">Facturas del Sector Educativo</div>
          <div class="fc-hero__sub">
            <v-icon x-small color="rgba(255,255,255,0.6)" class="mr-1">mdi-map-marker</v-icon>
            {{ $store.state.CARGO.sede.nombre }}
          </div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark>
        <v-icon left small>mdi-bank-outline</v-icon> Facturación
      </v-chip>
    </div>

    <div class="fc-body">

      <!-- Panel sucursales -->
      <v-card outlined class="fc-suc-card mb-4">
        <v-card-title class="fc-suc-card__title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-office-building-outline</v-icon>
          Sucursales y puntos de venta
          <v-progress-circular v-if="loadingsucursales" indeterminate size="16" width="2" color="indigo" class="ml-2" />
        </v-card-title>
        <v-card-text class="py-2 px-4">
          <v-row dense>
            <v-col v-for="(se, ind) in sucursales" :key="ind" cols="12" sm="6" md="3">
              <div class="fc-suc-item">
                <div class="fc-suc-item__nro">Suc. {{ se.sucursal.numero_sucursal }}</div>
                <div class="fc-suc-item__nit">NIT: {{ se.sucursal.nro_nit }}</div>
                <div v-if="se.punto_venta.nombre" class="fc-suc-item__pv">
                  <v-chip x-small color="indigo lighten-5" class="indigo--text text--darken-2 mr-1">
                    PV {{ se.punto_venta.codigo_punto_venta }}
                  </v-chip>
                  {{ se.punto_venta.nombre }} — {{ se.punto_venta.descripcion }}
                </div>
                <div v-else class="fc-suc-item__pv grey--text">Sin punto de venta</div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Filtros -->
      <v-card outlined class="fc-filters-card mb-4">
        <v-card-title class="fc-filters-card__title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-filter-outline</v-icon>
          Filtros de búsqueda
        </v-card-title>
        <v-card-text class="pt-2 pb-3 px-4">
          <v-row dense>
            <v-col cols="12" sm="3">
              <v-select :items="meses" v-model="xmes" label="Mes" item-value="id"
                outlined dense clearable hide-details prepend-inner-icon="mdi-calendar-month-outline" />
            </v-col>
            <v-col cols="12" sm="2">
              <v-select :items="gestiones" v-model="xanio" label="Gestión" item-value="id"
                outlined dense clearable hide-details prepend-inner-icon="mdi-calendar-range" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select v-model="docsector" :items="docssector" label="Documento Sector"
                item-value="id" outlined dense hide-details prepend-inner-icon="mdi-file-document-outline" />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="suc_sel" :items="sucursales" item-text="xtext"
                label="NIT / Sucursal" return-object outlined dense hide-details
                prepend-inner-icon="mdi-office-building" />
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="search" label="Buscar por Nro. Factura o Razón Social..."
                hide-details outlined dense clearable
                prepend-inner-icon="mdi-magnify"
                append-icon="mdi-file-search"
                v-on:keyup.enter="getdatos(suc_sel)"
                @click:clear="getdatosClear(suc_sel)"
                @click:append="getdatos(suc_sel)" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="fc-table-card">
        <div class="d-flex align-center justify-space-between px-4 py-2 fc-table-topbar">
          <v-chip x-small :color="desserts.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ totalDesserts }} factura{{ totalDesserts !== 1 ? 's' : '' }}
          </v-chip>
          <download-excel
            :disabled="desserts.length === 0"
            :data="desserts"
            :fields="json_fields"
            worksheet="Facturas"
            :stringifyLongNum="true"
            name="facturas.xls">
            <v-btn small outlined color="green darken-1" :disabled="desserts.length === 0">
              <v-icon left small>mdi-microsoft-excel</v-icon> Exportar Excel
            </v-btn>
          </download-excel>
        </div>

        <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="loading"
          :search="search"
          :options.sync="options"
          :server-items-length="totalDesserts"
          :items-per-page="size"
          :items-per-page-options="[5,15,-1]"
          disable-items-per-page
          loading-text="Cargando facturas..."
          no-data-text="No hay facturas para los filtros seleccionados"
          sort-by="calories"
          class="fc-table"
        >
          <template v-slot:[`item.numeroFactura`]="{ item }">
            <span class="font-weight-medium">{{ item.numeroFactura || item.nroFactura }}</span>
          </template>

          <template v-slot:[`item.montoTotal`]="{ item }">
            <span class="teal--text text--darken-1 font-weight-medium">{{ item.montoTotal }}</span>
          </template>

          <template v-slot:[`item.estado`]="{ item }">
            <v-chip x-small label
              :color="item.estado && item.estado.includes('ANULACION') ? 'red lighten-5' : 'green lighten-5'"
              :class="item.estado && item.estado.includes('ANULACION') ? 'red--text text--darken-2' : 'green--text text--darken-2'">
              <v-icon left x-small>{{ item.estado && item.estado.includes('ANULACION') ? 'mdi-cancel' : 'mdi-check-circle-outline' }}</v-icon>
              {{ item.estado }}
            </v-chip>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-center" style="gap:2px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small color="blue darken-1" @click="visualizarpdf(item)">
                    <v-icon small>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver PDF de factura</span>
              </v-tooltip>

              <v-tooltip bottom v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small color="teal darken-1" @click="verificarestado(item)">
                    <v-icon small>mdi-check-decagram-outline</v-icon>
                  </v-btn>
                </template>
                <span>Verificar estado</span>
              </v-tooltip>

              <v-tooltip bottom v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small color="red darken-1"
                    :disabled="isanuladacheck(item)" @click="abrirAnularFactura(item)">
                    <v-icon small>mdi-file-cancel-outline</v-icon>
                  </v-btn>
                </template>
                <span>Anular factura</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>

    </div>

    <Registrar ref="registrar" v-on:facturageneradax="facturageneradax" />
    <Verfactura ref="verfactura" />
    <GenerarNota ref="generarnota" />
    <EventoViewFactura ref="verfacturaevento" />
    <Anular ref="anularfactura" v-on:anuladofact="anuladofact" />
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import Registrar from '@/views/rfacturascv/registrar.vue';
  import Verfactura from '@/views/rfacturascv/verfactura.vue';
  import EventoViewFactura from '@/views/recibos/esignificativos/eventoviewfactura.vue';
  import Anular from '@/views/recibos/AnularFE.vue';
  import GenerarNota from '@/views/rfacturascv/regnota.vue';
  import gql from 'graphql-tag';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loadingsucursales: false,
      loading: false,
      sucursales: [],
      gestiones: [],
      nits: [],
      search: '',
      xmes: null,
      xanio: null,
      suc_sel: null,
      headers: [
        { text: 'Numero Factura', value: 'numeroFactura', width: 40 },
        { text: 'Razon Social', value: 'nombreRazonSocial' },
        /* { text: 'Estudiante', value: 'nombreEstudiante' },
      { text: 'Doc.', value: 'numeroDocumento' }, */
        { text: 'Monto total', value: 'montoTotal' },
        { text: 'Correo', value: 'email' },
        // { text: 'Codigo Recepcion', value: 'codigoRecepcion' },
        { text: 'Estado', value: 'estado' },
        { text: 'Opciones', value: 'actions', sortable: false, width: 120 },
      ],
      desserts: [],
      desserts2: [],
      //
      json_fields: {
        'Numero Factura': 'numeroFactura',
        'Razon Social': 'nombreRazonSocial',
        'Monto total': 'montoTotal',
        Correo: 'email',
        'Codigo Recepcion': 'codigoRecepcion',
        ESTADO: 'estado',
        'Codigo Anulacion': 'codigoAnulacion',
        'Codigo Documento Sector': 'codigoDocumentoSector',
        'Email Estado': 'emailEstado',
        'Fecha Emision': 'fechaEmision',
        Nit: 'nit',
        'Nombre Estudiante': 'nombreEstudiante',
        'Nombre Razon Social': 'nombreRazonSocial',
        'Numero Documento': 'numeroDocumento',
        'Periodo Facturado': 'periodoFacturado',
        Telefono: 'telefono',
        Usuario: 'usuario',
      },
      json_meta: [[{ key: 'charset', value: 'utf-8' }]],
      options: {itemsPerPage:15},
      totalDesserts: 0,
      size: 15,
      presave_suc: null,
      meses: [
        { id: 1, text: 'enero' },
        { id: 2, text: 'febrero' },
        { id: 3, text: 'marzo' },
        { id: 4, text: 'abril' },
        { id: 5, text: 'mayo' },
        { id: 6, text: 'junio' },
        { id: 7, text: 'julio' },
        { id: 8, text: 'agosto' },
        { id: 9, text: 'septiembre' },
        { id: 10, text: 'octubre' },
        { id: 11, text: 'noviembre' },
        { id: 12, text: 'diciembre' },
      ],
      docssector: [
        // { id: 1, text: 'COMPRA Y VENTA' },
        { id: 11, text: 'SECTOR EDUCATIVO' },
        { id: 46, text: 'SECTOR EDUCATIVO ZONA FRANCA' },
        // monto sujeto iva cuando es  46
      ],
      docsector: 11,
    }),

    components: { Registrar, Verfactura, EventoViewFactura, Anular, GenerarNota },
    watch: {
      '$store.state.CARGO.sede': function () {
        this.getSucursalesBySede();
      },
      xmes: function () {
        this.getdatos(this.suc_sel);
      },
      xanio: function () {
        this.getdatos(this.suc_sel);
      },
      suc_sel: function () {
        // window.console.log(this.suc_sel);
        this.getdatos(this.suc_sel);
      },
      docsector: function () {
        this.getdatos(this.suc_sel);
      },
      options: {
        handler() {
          //window.console.log('options', this.options);
          this.getdatos(this.presave_suc, false);
        },
        deep: true,
      },
    },
    created() {
      this.initialize();
      // demo
      // this.getLeyendas(1);
    },

    methods: {
      initialize() {
        const date = new Date();
        this.xmes = date.getMonth()+1;
        this.xanio = date.getFullYear();
        this.getGestiones();
        this.getSucursalesBySede();
      },
      getSucursalesBySede() {
        let sedeid = this.$store.state.CARGO.idsede;
        let vue = this;
        this.sucursales = [];
        this.desserts = [];
        this.desserts2 = [];
        vue.loadingsucursales = true;

        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sedeID=${sedeid}`;
        let url2 = `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`;
        const promise = xaxios.get(url);
        const promise2 = xaxios.get(url2);

        Promise.all([promise, promise2])
          .then(function (values) {
            let data = values[0].data.data;

            let data2 = values[1].data.data;
            data2.map((x) => {
              x.xtext = `${x.nro} [${x.tipo_facturacion}]`;
            });
            let xxxnits = [];

            data.map((x) => {
              x.xtext = `${x.sucursal.nro_nit} [${x.sucursal.numero_sucursal}]`;
              let n = data2.find((n) => n.nro == x.sucursal.nro_nit);
              x.xnit = n;
              if (!n || !n.apikey) x.xnit = { apikey: 'nro_nit_apikey_not_found' };
              xxxnits.push(n);
            });

            vue.nits = xxxnits;
            vue.sucursales = data;
            vue.loadingsucursales = false;
            vue.suc_sel = vue.sucursales[0];
            // vue.getdatos(vue.sucursales[1]);
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loadingsucursales = false;
          });
      },

      getGestiones() {
        this.$apollo
          .query({
            query: gql`
              query {
                getGestiones {
                  gestion
                }
              }
            `,
          })
          .then(({ data: { getGestiones } }) => {
            const data = getGestiones.reverse();
            data.map((x) => {
              x.id = x.gestion;
              x.text = x.gestion;
            });
            this.gestiones = data;
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      resetPage(){
        this.options.page = 0;
      },
      getdatosClear(){
        this.search = '';
        this.getdatos(this.suc_sel);
      },
      getdatos(sucursal, reset = true) {
        // window.console.log(sucursal, reset);
        if (!sucursal) return;
        if(reset) this.resetPage();
        this.presave_suc = { ...sucursal };
        this.desserts = [];
        this.desserts2 = [];
        let vue = this;
        this.loading = true;
        let documentoSector = this.docsector;
        let page = this.options.page;
        let zmes = '';
        let zanio = '';
        let zbus = '';
        if (!page) page = 0;
        else page -= 1;
        if(this.xmes) zmes = `&mes=${this.xmes}`;
        if(this.xanio) zanio = `&anio=${this.xanio}`;
        if(this.search) zbus = `&busqueda=${this.search}`;
        vue.size = this.options.itemsPerPage;
        if(vue.size < 0 ) vue.size = 150000; // max 

        var config = {
          method: 'get',
          // url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas`,
          // url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/documentosector/${documentoSector}`,
          // url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/sucursal/${sucursal.sucursal.numero_sucursal}/puntoventa/${sucursal.punto_venta.codigo_punto_venta}/documentosector/${documentoSector}`,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/sucursal/${sucursal.sucursal.numero_sucursal}/puntoventa/${sucursal.punto_venta.codigo_punto_venta}/documentosector/${documentoSector}?page=${page}&size=${vue.size}${zmes}${zanio}${zbus}`,
          headers: {
            //apikey: this.$store.getters.getApiKey,
            apikey: sucursal.xnit.apikey,
          },
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data;
            let datos = data;
            // window.console.log(response.data);
            if(data.data) {
              data = data.data;
              data.content.forEach(x=>{
                x.numeroFactura = x.numeroFactura?x.numeroFactura:x.nroFactura;
                x.codigoDocumentoSector = x.codigoDocumentoSector?x.codigoDocumentoSector:x.codigoTipoDocumentoSector;
                x.numeroDocumento = x.numeroDocumento?x.numeroDocumento:x.nroDocumentoIdentidad;
                if(x.camposEspecificos){
                  let est = x.camposEspecificos.nombreEstudiante;
                  let per = x.camposEspecificos.periodoFacturado;
                  x.nombreEstudiante = est;
                  x.periodoFacturado = per;
                }
              });
              datos = data.content;
              vue.totalDesserts = data.totalElements;
            }else {
              vue.totalDesserts = datos.length;
            }

            vue.desserts = datos;
            vue.desserts2 = datos;
            vue.loading = false;
            //vue.filtrarpormes();
          })
          .catch(function (error) {
            vue.loading = false;
            window.console.log(error);
          });
      },

      newregsucursal() {
        this.initialize();
      },
      editItem() {
        let sucursal = this.sucursales[0];
        this.$refs.registrar.showThisView(sucursal);
      },
      isanuladacheck(item) {
        if (item.estado.includes('ANULACION CONFIRMADA')) return true;
        return false;
      },
      verItem(item) {
        this.$refs.verfacturaevento.openmodal(item);
      },
      generarnotadc(item) {
        this.$refs.generarnota.openmodal(item);
      },
      abrirAnularFactura(item) {
        this.$refs.anularfactura.openmodal(item);
      },
      facturageneradax(data) {
        this.initialize();
        this.$refs.verfactura.openmodal(data);
      },
      visualizarpdf(item) {
        //window.console.log("ver fact suc_sel",this.suc_sel);
        let fact = { venta: item, xapikey: this.suc_sel.xnit.apikey };
        this.$refs.verfactura.openmodal(fact);
      },
      anuladofact() {
        this.initialize();
      },
      verificarestado(item) {
        let vue = this;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para Sincronizar Catalogo.',
          okText: 'Verificar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar',
          body: '<br> <b>NOTA:</b> Esta accion es irreversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function (dialog) {
            vue.verificarestado2(item, dialog);
          })
          .catch(function () {});
      },
      verificarestado2(item, dialog) {
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/verificar/${item.id}`,
          headers: {
            'Content-Type': 'application/json',
            // apikey: this.$store.getters.getApiKey,
            apikey: vue.suc_sel.xnit.apikey,
          },
        };

        xaxios.request(config)
          .then(function (response) {
            window.console.log('response', response);
            dialog.close();
            vue.initialize();
            let data = response.data.respuestaServicioFacturacion;
            let mensaje = 'Descripcion: ' + data.codigoDescripcion;

            vue.$root.$notify.show(mensaje, { color: 'success' });
          })
          .catch(function (error) {
            window.console.log(error);
            dialog.close();
            let data = error.response.data.respuestaServicioFacturacion;
            let mensaje = data.mensaje;
            let txt = data.codigoDescripcion;
            if (mensaje) txt += ` Error ${mensaje}`;
            else txt += ` ${data.mensajesList[0].codigo} - ${data.mensajesList[0].descripcion}`;
            vue.$root.$notify.show(txt, { color: 'red' });
          });
      },
      filtrarpormes() {
        let vue = this;
        let zmes = (this.xmes + '').padStart(2, '0');
        window.console.log('zmes::',zmes);
        this.desserts = this.desserts2.filter((x) => {
          if (!vue.xmes) return true;
          if (x.fechaEmision.includes(`/${zmes}/`)) return true;
          return false;
        });
      },
    },
  };
</script>

<style scoped>
.fc-page { min-height: 100vh; background: #f5f7fa; }

.fc-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.fc-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.fc-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.fc-body { padding: 20px 24px; }

.fc-suc-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.fc-suc-card__title {
  font-size: 0.8rem !important; font-weight: 700 !important;
  color: #283593; letter-spacing: 0.02em; border-bottom: 1px solid #e8edf7;
}
.fc-suc-item {
  background: #f8f9ff; border: 1px solid #e3e8f0;
  border-radius: 8px; padding: 8px 12px;
}
.fc-suc-item__nro { font-size: 0.72rem; font-weight: 700; color: #1a237e; text-transform: uppercase; letter-spacing: 0.04em; }
.fc-suc-item__nit { font-size: 0.78rem; color: #546e7a; margin-bottom: 4px; }
.fc-suc-item__pv  { font-size: 0.75rem; color: #546e7a; }

.fc-filters-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.fc-filters-card__title {
  font-size: 0.8rem !important; font-weight: 700 !important;
  color: #283593; letter-spacing: 0.02em; border-bottom: 1px solid #e8edf7;
}

.fc-table-card    { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }
.fc-table-topbar  { border-bottom: 1px solid #e8edf7; background: #fafbff; }
.fc-table >>> thead tr th {
  background: #e8edf7 !important; color: #1a237e !important;
  font-size: 0.72rem !important; font-weight: 700 !important;
  text-transform: uppercase; letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important; padding: 8px 14px !important;
}
.fc-table >>> tbody tr:hover { background: #f0f4ff !important; }
.fc-table >>> tbody tr td {
  font-size: 0.85rem; border-bottom: 1px solid #f0f0f0 !important; padding: 6px 14px !important;
}
</style>
